<template>
	<div class="notification-container mt-2">
		<template v-if="showloader">
			<b-skeleton class="w-50"></b-skeleton>
		</template>
		<div
			v-if="!showloader"
			class="candash-modal-head-2 d-flex align-items-center"
		>
			<img
				class="mr-2"
				src="../../../assets/newdesign/dashboard/noti.svg"
				alt=""
			/>Notification
		</div>
		<div v-if="showloader" class="noti-scroll">
			<b-skeleton class="w-75 mt-4"></b-skeleton>
			<div v-for="i in 2" :key="i" style="height: 90px">
				<b-skeleton class="h-100 w-100 mt-3"></b-skeleton>
			</div>
			<b-skeleton class="w-75 mt-5"></b-skeleton>
			<div v-for="i in 2" :key="i" style="height: 90px">
				<b-skeleton class="h-100 w-100 mt-3"></b-skeleton>
			</div>
		</div>

		<template
			v-if="(jdProgress.length > 0 || ongoing.length > 0) && !showloader"
		>
			<div class="noti-scroll">
				<div class="candash-blktxt-bold mt-4">My Job Progress</div>
				<div
					v-for="(jd, index) in jdProgress"
					:key="index + 'jd'"
					@click="gotoJdProgress()"
					class="noti-card d-flex align-items-center m-1 mt-3 w-95 pointer"
				>
					<div>
						<img
							src="../../../assets/newdesign/dashboard/buildNoti.svg"
							alt=""
						/>
					</div>
					<div class="ml-2 w85">
						<div class="w-100 text-truncate noti-title">
							Simplify3x software private limited
						</div>
						<div>
							<span class="greytxt">Applied For:</span>&nbsp;&nbsp;<span
								class="bold-bluetxt"
								>{{ jd.jobName }}
							</span>
						</div>
					</div>
				</div>
				<div class="candash-blktxt-bold mt-5">My Assessment progress</div>
				<div
					v-for="(assessment, index) in ongoing"
					:key="index + 'ongoing'"
					class="noti-card d-flex align-items-center m-1 mt-3 w-95 pointer"
					@click="
						gotoAssessmentProgress(assessment.testID, assessment.testStatus)
					"
				>
					<div>
						<img src="../../../assets/newdesign/dashboard/assNoti.svg" alt="" />
					</div>
					<div class="ml-2 w85">
						<div class="w-100 text-truncate noti-title">
							{{ assessment.testName }}
						</div>
						<div class="d-flex align-items-center mt-1">
							<div class="d-flex align-items-center greytxt">
								<img
									class="mr-2"
									src="../../../assets/newdesign/dashboard/calenNoti.svg"
									alt=""
								/>{{ formatDate(assessment.startTime) }}
							</div>
							<div class="d-flex align-items-center noti-greentxt ml-4">
								<img
									class="mr-2"
									src="../../../assets/newdesign/dashboard/statusNoti.svg"
									alt=""
								/>Ongoing
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template
			v-if="(jdProgress.length === 0 || ongoing.length === 0) && !showloader"
		>
			<div
				class="noti-scroll d-flex flex-column align-items-center justify-content-center"
			>
				<img
					class="mt-5"
					src="../../../assets/newdesign/dashboard/noNoti.svg"
					alt=""
				/>
				<div class="greytxt text-center mt-5 mb-5">
					Your recent activity about job and assessment progress will be updated
					here
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import {
	getAssessProg,
	dashboardJDProgress,
} from "../../../utils/apiFunctions";
export default {
	data() {
		return {
			loopvar: 2,
			jdProgress: [],
			ongoing: [],
			showloader: false,
		};
	},
	created() {
		this.getAssessmentsProg();
		this.getJDProgress();
		this.showloader = true;
	},

	methods: {
		async getJDProgress() {
			try {
				const response = await dashboardJDProgress();
				if (response.status === 200) {
					this.jdProgress = response.data.data;
				} else {
					this.jdProgress = [];
				}
				this.jdLoader = false;
			} catch (error) {
				this.jdLoader = false;
				console.log(error);
			}
		},
		gotoJdProgress() {
			this.$router.push({
				name: "CandJdProgress",
			});
		},
		gotoAssessmentProgress(testId, teststatus) {
			this.$router.push({
				name: "CandidateAssessmentProgress",
				query: { testId: testId, testStatus: teststatus },
			});
		},
		async getAssessmentsProg() {
			try {
				const response = await getAssessProg();
				if (response.status === 200) {
					this.ongoing = response.data.data.ongoing;
					this.showloader = false;
				}
				this.assessmentLoader = false;
			} catch (error) {
				console.log(error);
			}
		},
		formatDate(inputDate) {
			const date = new Date(inputDate);

			const day = String(date.getUTCDate()).padStart(2, "0");
			const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
			const year = date.getUTCFullYear();
			const hours = String(date.getUTCHours()).padStart(2, "0");
			const minutes = String(date.getUTCMinutes()).padStart(2, "0");

			const ampm = hours >= 12 ? "PM" : "AM";
			const formattedHours = hours % 12 || 12; // Convert to 12-hour format

			const formattedDate = `${day}-${month}-${year} ${formattedHours}:${minutes} ${ampm}`;

			return formattedDate;
		},
	},
};
</script>

<style></style>
